import { Component, OnDestroy, OnInit } from '@angular/core';
import { DashboardWidgetChartComponent } from '../../dashboard-widget-chart/dashboard-widget-chart.component';
import { BooleanStateService } from 'src/app/modules/core/services/boolean-state.service';
import { CommunicationService } from 'src/app/services/communication';
import { ParameterHandlerService, CacheService } from 'projects/common/src/app/services';
import { StateSidebarService } from 'src/app/modules/sidebar/services/state-sidebar.service';
import { MachineContextService } from 'src/app/modules/core/services/parameter/machine-context/machine-context.service';
import { LanguageService } from 'projects/common/src/app/services/parameters';
import { DatePresentationPipe } from 'src/app/modules/core/pipes/date-presentation.pipe';
import { ITransitLoopsBzn } from 'src/app/modules/widget/interfaces/transit-loops-bzn';
import { IMachineLoopsData } from 'src/app/modules/widget/interfaces/machine-loops-data';
import Highcharts from 'highcharts';
import { IShift } from 'src/app/modules/core/interfaces';
import { hexToRGB } from 'projects/common/src/app/services/utils/utilities';
import { ScreenViewService } from 'src/app/modules/widget/services/screen-view.service';

@Component({
  selector: 'app-transit-loops-bzn',
  templateUrl: './transit-loops-bzn.component.html',
  styleUrls: ['./transit-loops-bzn.component.scss'],
})
export class TransitLoopsBznComponent extends DashboardWidgetChartComponent implements OnInit, OnDestroy {
  public displayMessage: boolean;

  constructor(
    protected progressBarService: BooleanStateService,
    protected communication: CommunicationService,
    protected parameterService: ParameterHandlerService,
    protected sidebarService: StateSidebarService,
    protected cacheService: CacheService,
    protected machineContext: MachineContextService,
    private langService: LanguageService,
    private datePipe: DatePresentationPipe,
    private languageService: LanguageService,
    protected screenViewService: ScreenViewService,
  ) {
    super(progressBarService, communication, parameterService, sidebarService, cacheService, machineContext, screenViewService);
    this.initRequestParams();
  }

  /**
   * Init request params
   */
  protected initRequestParams(): void {
    this.params = {
      hasCompany: true,
      hasDate: true,
      hasShift: true,
    };
  }

  /**
   * Function to draw view
   *
   * @param chartOptions Options
   */
  public drawView(transitLoopData: ITransitLoopsBzn[]): void {
    const date = this.parameterService.parameters.item('date').value;
    const shift = this.parameterService.parameters.item('shift').value as IShift;
    const user = this.parameterService.parameters.item('user-data').value;
    const machineType = this.parameterService.parameters.item('machine-context').value || 'no disponible';

    const originalData = transitLoopData;
    this.displayMessage = !transitLoopData.length;

    const donutChart = {
      chart: {
        marginLeft: -300,
        marginTop: -40,
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
        shadow: false,
        type: 'pie',
        backgroundColor: '#F8F8F8',
      },
      credits: {
        enabled: false,
      },
      title: {
        text: '',
      },
      subtitle: {
        text: `${this.langService.message('company')}: ${user.company.name},
            ${this.langService.message('device')}: ${this.langService.message(machineType.name)},
            ${this.langService.message('date')}: ${this.datePipe.transform(date)},
            ${this.langService.message('shift_')}: ${shift.name}`,
      },
      legend: {
        // Hiding legend's default symbol
        symbolHeight: 0.001,
        symbolWidth: 0.001,
        symbolRadius: 0.001,
        layout: 'vertical',
        verticalAlign: 'middle',
        x: 180,
        y: -40,
        useHTML: true,
        labelFormatter(): string {
          let legendSymbol = '';
          let totalSymbol = '';
          let totalLoops = 0;
          Highcharts.each(this.series.data, (seriesData: { y: number }) => {
            totalLoops += seriesData.y;
          });
          totalSymbol = `
                           <div style="width: 210px; height: 20px; margin-top: 30px;">
                              <div style="width: 30px; height: 12px; float:left; margin-top: 3px;">
                                 <div style="border: 2px solid #B2B2B2 ;width: 15px;height: 12px; float:left;">
                                    <div style="background: #B2B2B2 ;width: 13px;height: 10px;opacity: 0.5;"></div>
                                 </div>
                                 <div style="border: 2px solid #FF9933;width: 15px;height: 12px; float:right;">
                                    <div style="background: #FF9933;width: 13px;height: 10px;opacity: 0.5;"></div>
                                 </div>
                              </div>
                              <span style="font-size: 12px; font-family: Open Sans; font-weight: 500; color: #433E3E;
                              margin-left: 10px; float: left;">${this.name}: ${totalLoops} Viajes</span>
                           </div>`;
          legendSymbol = `
                           <div style="width: 250px; height: 20px; margin-top: 30px;">
                              <div style="float: left; border: 2px solid ${this.borderColor}; width: 30px; height: 12px; margin-top: 3px;">
                                 <div style="float: left; background: ${this.color}; width: 28px;
                                 height: 10px;float: left;">
                                 </div>
                              </div>
                              <span style="font-size: 12px; font-family: Open Sans; font-weight: 500; color: #433E3E;
                              margin-left: 10px; float: left;">${this.name}: ${this.y} Viajes</span>
                           </div>`;
          if (this.name === 'Total Buzones') {
            return `${totalSymbol}`;
          }
          return `${legendSymbol}`;
        },
      },
      tooltip: {
        backgroundColor: '#333333',
        borderColor: '#333333',
        borderRadius: '2',
        opacity: 0.9,
        style: {
          color: '#FFFFFF',
          fontSize: '10px',
        },
        useHTML: true,
        formatter(): string {
          let machineName = '';
          let machineLoops = '';
          const bzName = this.point.name;
          originalData.sort((a, b) => (a.machineName < b.machineName ? -1 : 1));
          Highcharts.each(originalData, (machineData: IMachineLoopsData) => {
            if (machineData.trainStatus === 'BZG-OUT' && bzName === 'Buzones Gruesos') {
              machineName += `<a>${machineData.machineName}</a><br>`;
              machineLoops += `<a>${machineData.loops}</a><br>`;
            }
            if (machineData.trainStatus === 'BZF-OUT' && bzName === 'Buzones Finos') {
              machineName += `<a>${machineData.machineName}</a><br>`;
              machineLoops += `<a>${machineData.loops}</a><br>`;
            }
          });
          return `
                  <div class="container">
                     <div class= "row" style= "opacity: 0.9; width: 130px; color: #FFFFFF; font-family: Open Sans; font-size: 10px;">
                        <div style= "float: left;">
                           <span style ="font-weight: 600;">Equipos</span>
                           <div align="left">
                              ${machineName.toUpperCase()}
                           </div>
                        </div>
                        <div" style= "float: right; margin-left: 50px;">
                           <span style ="font-weight: 600;">Viajes</span>
                           <div align="right">
                              ${machineLoops}
                           </div>
                        </div>
                     </div>
                  </div>
                  `;
        },
      },
      plotOptions: {
        pie: {
          size: '220px',
          innerSize: '40%',
          showInLegend: true,
          borderWidth: 2,
          point: {
            events: {
              legendItemClick(): boolean {
                return false;
              },
            },
          },
          dataLabels: {
            enabled: true,
            format: '<b>{point.percentage:.1f}%',
            distance: -30,
            color: '#FFFFFF',
            style: {
              textOutline: 0,
              color: '#FFFFFF',
            },
          },
        },
      },
      series: [
        {
          data: [
            {
              name: this.languageService.message('bzng'),
              y: this.countBzg(originalData),
              color: hexToRGB('#FF9933', '0.5'),
              borderColor: '#FF9933',
            },
            {
              name: this.languageService.message('bznf'),
              y: this.countBzf(originalData),
              color: hexToRGB('#B2B2B2', '0.5'),
              borderColor: '#B2B2B2',
            },
            { name: this.languageService.message('bzntotal'), y: null, color: '#000000' },
          ],
          states: {
            hover: {
              enabled: true,
              halo: {
                size: 0,
              },
            },
          },
        },
      ],
    };

    this.chart = Highcharts.chart(this.chartTarget.nativeElement, donutChart as any, () => {});
  }

  /**
   * Function to count loops to bzg
   *
   * @param machineLoops Data from transit loops bzn
   */
  private countBzg(machineLoops: ITransitLoopsBzn[]): number {
    let countBzg = 0;
    machineLoops.forEach((element) => {
      if (element.trainStatus === 'BZG-OUT') {
        countBzg += element.loops;
      }
    });
    return countBzg;
  }

  /**
   * Function to count loops to bzf
   *
   * @param machineLoops Data from transit loops bzn
   */
  private countBzf(machineLoops: ITransitLoopsBzn[]): number {
    let countBzf = 0;
    machineLoops.forEach((element) => {
      if (element.trainStatus === 'BZF-OUT') {
        countBzf += element.loops;
      }
    });
    return countBzf;
  }

  /**
   * On destroy component
   */
  public onDestroy(): void {
    super.ngOnDestroy();
  }
}
